import React from 'react'

interface StarRatingProps extends React.HTMLAttributes<HTMLDivElement> {
  count?: number // Number of stars
  size?: number // Size of each star in px
  value: number // Rating value
  color?: string // Color for filled stars
}

const StarRating: React.FC<StarRatingProps> = ({
  count = 5,
  size = 32,
  value,
  color = 'var(--color-warning)',
  ...rest
}) => {
  const safeValue = Math.max(0, Math.min(value, count))

  return (
    <div
      style={{
        display: 'flex',
        gap: 4,
        cursor: 'default',
        userSelect: 'none',
        pointerEvents: 'none'
      }}
      {...rest}
      tabIndex={-1}>
      {Array.from({ length: count }).map((_, idx) => {
        let fill = 0
        if (safeValue >= idx + 1) fill = 1
        else if (safeValue > idx) fill = safeValue - idx

        return (
          <svg
            key={idx}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            style={{ display: 'block', pointerEvents: 'none' }}
            tabIndex={-1}
            aria-label={`Rate ${idx + 1} star${idx === 0 ? '' : 's'}`}>
            <defs>
              <linearGradient id={`star-grad-${idx}`} x1="0" x2="1" y1="0" y2="0">
                <stop offset={`${fill * 100}%`} stopColor={color} />
                <stop offset={`${fill * 100}%`} stopColor="white" stopOpacity="0" />
              </linearGradient>
            </defs>
            <polygon
              points="12,2 15,9 22,9.5 17,14.5 18.5,22 12,18.5 5.5,22 7,14.5 2,9.5 9,9"
              fill={`url(#star-grad-${idx})`}
              stroke={color}
              strokeWidth="1"
            />
          </svg>
        )
      })}
    </div>
  )
}

export default StarRating
